import {
    SHIFTS_SAGA_GET_OPEN_SHIFTS,     SHIFTS_SAGA_GET_PLANNED_SHIFTS, SHIFTS_SAGA_SET_TAB,
} from '../actionTypes'

export const getPlannedShifts = () => ({ type: SHIFTS_SAGA_GET_PLANNED_SHIFTS })
export const getOpenShifts = () => ({ type: SHIFTS_SAGA_GET_OPEN_SHIFTS })
export const setShiftsTab = (tab, history) => ({ type: SHIFTS_SAGA_SET_TAB, tab, history })
